



























import { Component, Emit, Ref, Vue } from 'vue-property-decorator';
import HolderNew from '@/components/ProductVariantHolder/HolderNew.vue';
import SPopup from '@/components/UI/Popup/SPopup.vue';

@Component({
  components: {
    HolderNew,
  },
})
export default class HolderNewButton extends Vue {
  private showDialog = false;

  @Ref() public parentPopup?: SPopup

  @Emit()
  private productVariantHolderCreated() {
    this.showDialog = false;
    this.$emit('product-variant-holder-created');
  }
}
